import { useDraggable } from "@dnd-kit/core";
import { Draggable } from "../Draggable";
import { TSortWordsExerciseParsedWord } from "types/app/exercises";
import "./DraggableItem.styles.scss";

type TDraggableItemProps = {
  /**
   * Word data item for the draggable component.
   */
  word: TSortWordsExerciseParsedWord;
  /**
   * Indicates if draggable word is placed in correct column.
   * @default false
   */
  correct?: boolean;
  /**
   * Indicates whenever to show exercise results.
   * @default false
   */
  showResult?: boolean;
};

export const DraggableItem: React.FC<TDraggableItemProps> = (props) => {
  const { word, correct = false, showResult = false } = props;

  const { isDragging, setNodeRef, listeners } = useDraggable({
    id: word.id,
    data: { word },
    disabled: showResult,
  });

  return (
    <Draggable
      ref={setNodeRef}
      dragging={isDragging}
      listeners={listeners}
      content={word.content}
      correct={correct}
      showResult={showResult}
    />
  );
};
